/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPublishContent = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m18.586 18-1.293-1.293 1.414-1.414L22.414 19l-3.707 3.707-1.414-1.414L18.586 20H15v-2zM5 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM2 5a3 3 0 1 1 5.708 1.293l1.535 1.535C10.033 7.305 10.98 7 12 7s1.967.305 2.757.828l1.535-1.535a3 3 0 1 1 1.414 1.414l-1.534 1.536a5 5 0 0 1-6.929 6.929l-1.535 1.535a3 3 0 1 1-1.414-1.414l1.534-1.536C7.305 13.967 7 13.02 7 12s.305-1.967.828-2.757L6.293 7.708A3 3 0 0 1 2 5zm17-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-7 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-7 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPublishContent as PublishContent };
